import React from 'react';

import { isNil } from 'lodash';
import { MdAdd } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import {
  getNewProgressReportUri,
  getNewRosterReportUri,
} from '@modules/reports/customReports/duck/utils';
import { Button, Dropdown, Menu } from '@modules/shared/components';
import {
  isCouncilAdminSel,
  organizationGuidSel,
  unitTypeIdSel,
} from '@modules/shared/duck';

const MenuItem = Menu.Item;
const MenuDivider = Menu.Divider;

export const NewCustomReportButton = () => {
  const unitTypeId = useSelector(unitTypeIdSel);
  const isCouncilAdmin = useSelector(isCouncilAdminSel);
  const orgGuid = useSelector(organizationGuidSel);

  const handleMenuClick = ({
    key,
  }: {
    key: 'rosterReport' | 'progressReport';
  }) => {
    if (isNil(unitTypeId)) {
      return;
    }

    // Don't pass orgGuid if seeing their units
    // Pass if council Admin seeing below unit

    if (key === 'rosterReport') {
      window.open(
        getNewRosterReportUri({
          unitTypeId,
          orgGuid: isCouncilAdmin ? orgGuid : null,
        }),
        '_blank',
      );
    }

    if (key === 'progressReport') {
      window.open(
        getNewProgressReportUri({
          unitTypeId,
          orgGuid: isCouncilAdmin ? orgGuid : null,
        }),
        '_blank',
      );
    }
  };

  const buttons = (
    <Menu onClick={handleMenuClick}>
      <MenuItem key={'rosterReport'}>
        <FormattedMessage id="reports.customReport.newRosterReport" />
      </MenuItem>
      <MenuDivider />
      <MenuItem key={'progressReport'}>
        <FormattedMessage id="reports.customReport.newProgressReport" />
      </MenuItem>
    </Menu>
  );

  return (
    <Dropdown overlay={buttons} trigger={['click']} placement="bottomLeft">
      <Button type="primary" shape="round" icon={<MdAdd />} uppercase={false}>
        <FormattedMessage id="reports.customReport.newReport" />
      </Button>
    </Dropdown>
  );
};
